exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.register-form.onlineform{\n  width: 100%;\n  max-width: 1400px;\n  margin: 0 auto;\n  padding-bottom: 40px;\n  padding-left: 0;\n}\n.register-form.onlineform .sign_up hr{\n  margin-bottom: 40px;\n  border-top: 1px solid #d2d2d2;\n  margin-top: 28px;\n}\n.register-form.onlineform .haserror .md-radio .md-radio-label{\n  color: #f00;\n}\n.register-form.onlineform .forstar label::after {\n  content: '*';\n  color: #f00;\n  font-size: 20px;\n}\n", ""]);

// exports
